import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SafeDrivingAgreeBottomSheet, {
  SafeDrivingAgreeBottomSheetProps,
} from '@di-shared/features/safe-driving-vDSP/SafeDrivingAgreeBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function SafeDrivingAgreeBottomSheetPage() {
  const {vin, termsData} = (window as any).data as SafeDrivingAgreeBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingAgreeBottomSheet
        vin={vin}
        termsData={termsData}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingAgreeBottomSheetPage;
